import { render } from "./AdmNave.vue?vue&type=template&id=c3461582&scoped=true"
import script from "./AdmNave.vue?vue&type=script&lang=js"
export * from "./AdmNave.vue?vue&type=script&lang=js"

import "./AdmNave.vue?vue&type=style&index=0&id=c3461582&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3461582"]])

export default __exports__